import Constants from 'expo-constants';

const normalizeUrl = (value: string): string => value.replace(/\/+$/, '');

const readRuntimeUrl = (key: 'apiUrl' | 'taxonomyApiUrl'): string => {
  const value = Constants.expoConfig?.extra?.[key];

  if (typeof value === 'string' && value.trim()) {
    return normalizeUrl(value.trim());
  }

  return '';
};

const getApiUrl = (): string => {
  const extraUrl = readRuntimeUrl('apiUrl');

  if (extraUrl) return extraUrl;

  if (__DEV__) return 'http://localhost:9000';

  return '';
};

const getTaxonomyUrl = (): string => {
  const url = readRuntimeUrl('taxonomyApiUrl');
  const taxonomySubPath = '/taxonomy';

  if (url) return url + taxonomySubPath;

  if (__DEV__) return 'http://localhost:9001';

  return taxonomySubPath;
};

const getBackendScope = (): string => {
  const scope = process.env.EXPO_PUBLIC_BACKEND_SCOPE;

  return scope ? scope.trim() : '';
};

const getAppBaseUrl = (): string => {
  const baseUrl = readRuntimeUrl('apiUrl');

  if (baseUrl) return baseUrl;

  if (__DEV__) return 'http://localhost:8081';

  return '';
};

export default {
  isDev: process.env.NODE_ENV === 'development',
  app: {
    baseUrl: getAppBaseUrl(),
  },
  api: {
    url: getApiUrl(),
    taxonomyUrl: getTaxonomyUrl(),
  },
  microsoftAuth: {
    tenantId: process.env.EXPO_PUBLIC_MICROSOFT_TENANT_ID,
    clientId: process.env.EXPO_PUBLIC_MICROSOFT_CLIENT_ID,
    backendScope: getBackendScope(),
  },
  mapbox: {
    style: 'mapbox://styles/woah-master-data/cmn4rzvzp000o01sc29c23n3u',
    accessToken:
      'pk.eyJ1Ijoid29haC1tYXN0ZXItZGF0YSIsImEiOiJjbGFrdHk0ODAwcG5zM3VtaHl6YXgzbnFsIn0.g55V6WZuVUnLCdbrgBcqRQ',
  },
  tilQueryApi: {
    url: 'https://api.mapbox.com/v4',
    accessToken:
      'pk.eyJ1Ijoid29haC1tYXN0ZXItZGF0YSIsImEiOiJjbGFrdHk0ODAwcG5zM3VtaHl6YXgzbnFsIn0.g55V6WZuVUnLCdbrgBcqRQ',
  },
};
